/**
 * @flow
 * @relayHash 7211dc185754314666109c68d9f5199e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Person_viewer$ref = any;
export type queries_PersonQueryVariables = {|
  id: string
|};
export type queries_PersonQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Person_viewer$ref
  |}
|};
export type queries_PersonQuery = {|
  variables: queries_PersonQueryVariables,
  response: queries_PersonQueryResponse,
|};
*/


/*
query queries_PersonQuery(
  $id: ID!
) {
  viewer {
    ...Person_viewer_1Bmzm5
    id
  }
}

fragment Person_viewer_1Bmzm5 on Viewer {
  id
  person(id: $id) {
    id
    personType
    description
    descriptionHtml
    firstName
    lastName
    createdAt
    updatedAt
    verticalImage
    smallAvatar
    birthdayAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_PersonQuery",
  "id": null,
  "text": "query queries_PersonQuery(\n  $id: ID!\n) {\n  viewer {\n    ...Person_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment Person_viewer_1Bmzm5 on Viewer {\n  id\n  person(id: $id) {\n    id\n    personType\n    description\n    descriptionHtml\n    firstName\n    lastName\n    createdAt\n    updatedAt\n    verticalImage\n    smallAvatar\n    birthdayAt\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_PersonQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Person_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_PersonQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "person",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID!"
              }
            ],
            "concreteType": "Person",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "personType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "descriptionHtml",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "verticalImage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "smallAvatar",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "birthdayAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '63469382ff29903e8b7a29f72b7fcb89';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_PersonQuery.graphql.js